import React, { Fragment } from "react"
import { connect } from "react-redux"
import { compose } from "redux"
import { createStructuredSelector } from "reselect"
import PropTypes from "prop-types"

import injectSaga from "utils/injectSaga"
import injectReducer from "utils/injectReducer"

import reducer from "./reducer"
import saga from "./saga"
import { makeSelectIsDownloading } from "./selectors"
import { getTemplate, uploadTemplate } from "./actions"
import "./index.less"
import { Helmet } from "react-helmet"
import { Link } from "react-router-dom"
import { LeftOutlined } from "@ant-design/icons"
import ImportScreen from "../../components/ImportScreen"
import importSvg from "../../images/empty-state-action-plans.svg"
import EmptyButton from "../../components/EmptyButton"

export function ActionPlansImport(props) {
  let fileInput
  const [idMeasure, setIdMeasure] = React.useState(
    parseInt(props.match.params.id_measure, 10)
  )

  const fileSelectedHandler = (event) => {
    event.preventDefault()
    const fd = new FormData()
    fd.append("uploaded_file", event.target.files[0])

    props.uploadTemplate(fd)
    fileInput.value = ""
  }

  return (
    <Fragment>
      <Helmet>
        <title>Planes de acción - Importación</title>
        <meta name="description" content="Description of Import" />
      </Helmet>
      <div style={{ padding: "32px 64px" }}>
        <Link
          style={{
            display: "flex",
            alignItems: "center",
          }}
          to="/action-plans">
          <LeftOutlined /> Seguimiento
        </Link>
      </div>
      <ImportScreen
        image={importSvg}
        title="Crea tus planes de acción"
        secondPoint="Llena los campos con los planes de acción de tu empresa."
        thirdPoint="Importa el Excel con la información de los planes de acción."
        description={`
            Crea los planes de acción de tu organización para trabajar las oportunidades de mejora identificadas en tu medición.
          `}>
        <EmptyButton
          size="large"
          label="Descargar plantilla"
          loading={props.isDownloading}
          onClick={() =>
            props.getTemplate({
              idMeasure,
            })
          }
        />
        <EmptyButton
          size="large"
          onClick={() => fileInput.click()}
          label="Importar planes de acción"
          style={{ marginLeft: "2rem" }}
        />
        <input
          style={{ display: "none" }}
          type="file"
          id="import"
          onChange={fileSelectedHandler}
          ref={(_fileInput) => (fileInput = _fileInput)}
        />
      </ImportScreen>
    </Fragment>
  )
}

ActionPlansImport.propTypes = {
  history: PropTypes.object,
  match: PropTypes.object,
  isDownloading: PropTypes.bool,
  getTemplate: PropTypes.func,
}

const mapStateToProps = createStructuredSelector({
  isDownloading: makeSelectIsDownloading(),
})

function mapDispatchToProps(dispatch) {
  return {
    getTemplate: (params) => dispatch(getTemplate(params)),
    uploadTemplate: (params) => dispatch(uploadTemplate(params)),
  }
}
const withConnect = connect(mapStateToProps, mapDispatchToProps)
const withReducer = injectReducer({ key: "actionPlansImport", reducer })
const withSaga = injectSaga({ key: "actionPlansImport", saga })

export default compose(withReducer, withSaga, withConnect)(ActionPlansImport)
